module.exports = __webpack_public_path__ + "static/gravity-regular-webfont-c1f461933b75fef530f0defc024df341.woff";